import { get } from 'lodash';

import BackendConnector from './backendConnector';

export default class EmailHttpService {
    static async getEmailTemplates(templateName, language = 'en-US') {
        const templates = await BackendConnector.get(`/metadata/emailTemplates/${language}/${templateName}`);

        return get(templates, 'templates', templates);
    }

    static async getEmailTemplatesList(templateName, language = 'en-US') {
        return BackendConnector.get(`/metadata/emailTemplatesList/${language}`);
    }

    static async updateEmailTemplate({ language = 'en-US', template }) {
        return BackendConnector.put('/metadata/emailTemplate/update', { language, template });
    }

    static async sendTestMessage({ subject, template }) {
        return BackendConnector.post('/metadata/emailTemplate/sendTestMessage', { subject, template });
    }

    static getUserDataByEmail(email) {
        return BackendConnector.post('/email/search', { email });
    }

    static getPublicEmailDomains() {
        return BackendConnector.get('email/publicDomains');
    }

    static requestRecruiterAssist(requestData) {
        return BackendConnector.post('/email/requestRecruiterAssist', requestData);
    }

    static toggleAutoContact(requestData) {
        return BackendConnector.post('/email/toggleAutoContact', requestData);
    }

    static getEmailStatusInfo(emails) {
        return BackendConnector.post('/email/status', emails);
    }

    static sendEmail(emailData) {
        return BackendConnector.post('/email', emailData);
    }

    static manuallyReportEmail(reportData) {
        return BackendConnector.post('/email/reportCandidatesEmailIssue', reportData);
    }

    static sendEmployerAtsSettingUpdatesNotification(data) {
        return BackendConnector.post('/email/employerAtsSettingUpdated', data);
    }
}
